<template>
  <div class="text-center text-primary-dark pt-5">
    <font-awesome-icon icon="spinner" class="fa-spin"/><br/>{{ texto }}
  </div>
</template>
<script>
export default {
  props: {
    texto: {
      default: 'Cargando'
    }
  }
}
</script>

